import { LazyQueryHookOptions, TypedDocumentNode, useLazyQuery, gql } from "@apollo/client";

import {
  SearchUsersQuery,
  SearchUsersQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { userFragment } from "src/graphql/anti-fraud/fragments/UserFragment";

export const searchUsersQuery = gql`
  query SearchUsers($limit: Int, $search: String!) {
    searchUsers(limit: $limit, string: $search) {
      ...UserFragment
    }
  }
  ${userFragment}
` as TypedDocumentNode<SearchUsersQuery, SearchUsersQueryVariables>;

export const useLazySearchUsersQuery = (
  options?: LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>
) => {
  return useLazyQuery(searchUsersQuery, options);
};
